module.exports = __webpack_public_path__ + "img/esh_no.7b443771.png";